// src/pages/DashboardPage.jsx
import StudentLayout from "../layouts/StudentLayout";
import Studentdb from './Studentdb';

const StudentPage = () => {

  return (
    <StudentLayout title="Student Details">
      {/* Main Content */}
      <div style={{ flex: 1 }}>
          <Studentdb />
      </div>
    </StudentLayout>
  );
};

export default StudentPage;
